import { render, staticRenderFns } from "./singleEffect.vue?vue&type=template&id=399c67f0&scoped=true"
import script from "./singleEffect.vue?vue&type=script&lang=js"
export * from "./singleEffect.vue?vue&type=script&lang=js"
import style0 from "./singleEffect.vue?vue&type=style&index=0&id=399c67f0&prod&lang=scss"
import style1 from "./singleEffect.vue?vue&type=style&index=1&id=399c67f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c67f0",
  null
  
)

export default component.exports